export type LaserGuideline = {
  laserType: string;
  skinType: string;
  indication: string;
  fluence: string;
  spotSize: string;
  pulseDuration: string;
  cooling: string;
  passes: string;
  sessions: string;
  contraindications: string[];
  preCare: string[];
  postCare: string[];
};

export const laserGuidelines: LaserGuideline[] = [
  // ALEXANDRITE 755nm - Hair Removal
  {
    laserType: "Alexandrite 755nm",
    skinType: "Type I",
    indication: "Hair Removal",
    fluence: "14-18",
    spotSize: "15-18",
    pulseDuration: "3",
    cooling: "Cryogen 30/30",
    passes: "1",
    sessions: "6-8 sessions, 4-6 weeks apart",
    contraindications: ["Recent sun exposure/tanning", "Photosensitizing medications", "Active infections (e.g. HSV)"],
    preCare: ["Shave area 24h prior", "Avoid sun for 4 weeks", "Discontinue isotretinoin for 6 months"],
    postCare: ["Apply soothing cream (e.g. Aloe Vera/Hydrocortisone)", "Strict sun protection (SPF 50+)", "Avoid hot baths/saunas for 48h"]
  },
  {
    laserType: "Alexandrite 755nm",
    skinType: "Type II",
    indication: "Hair Removal",
    fluence: "12-16",
    spotSize: "15-18",
    pulseDuration: "3-5",
    cooling: "Cryogen 30/30",
    passes: "1",
    sessions: "6-8 sessions, 4-6 weeks apart",
    contraindications: ["Recent sun exposure/tanning", "Photosensitizing medications", "Active infections"],
    preCare: ["Shave area 24h prior", "Avoid sun for 4 weeks", "Discontinue isotretinoin for 6 months"],
    postCare: ["Apply soothing cream", "Strict sun protection (SPF 50+)", "Avoid hot baths/saunas for 48h"]
  },
  {
    laserType: "Alexandrite 755nm",
    skinType: "Type III",
    indication: "Hair Removal",
    fluence: "10-14",
    spotSize: "15-18",
    pulseDuration: "10-20",
    cooling: "Cryogen 40/30",
    passes: "1",
    sessions: "6-8 sessions, 4-6 weeks apart",
    contraindications: ["Recent sun exposure/tanning", "History of keloids", "Active infections"],
    preCare: ["Shave area 24h prior", "Avoid sun for 4 weeks", "Use bleaching creams if tanned"],
    postCare: ["Apply soothing cream/topical steroid if needed", "Strict sun protection (SPF 50+)", "Avoid scratching"]
  },
  {
    laserType: "Alexandrite 755nm",
    skinType: "Type IV",
    indication: "Hair Removal",
    fluence: "8-12",
    spotSize: "12-15",
    pulseDuration: "20-40",
    cooling: "Cryogen 50/30",
    passes: "1",
    sessions: "6-10 sessions, 4-6 weeks apart",
    contraindications: ["Tanned skin", "Melasma (use caution)", "Active infections"],
    preCare: ["Shave area 24h prior", "Avoid sun strictly", "Test spot recommended"],
    postCare: ["Apply topical steroid to prevent PIH", "Strict sun protection (SPF 50+)", "Avoid heat"]
  },
  
  // Nd:YAG 1064nm - Hair Removal (Safe for Dark Skin)
  {
    laserType: "Nd:YAG 1064nm",
    skinType: "Type IV",
    indication: "Hair Removal",
    fluence: "30-40",
    spotSize: "12-15",
    pulseDuration: "20-30",
    cooling: "Cryogen 40/30",
    passes: "1",
    sessions: "6-10 sessions, 4-6 weeks apart",
    contraindications: ["Active infections", "Pregnancy (relative)"],
    preCare: ["Shave area 24h prior", "Avoid sun for 4 weeks"],
    postCare: ["Apply soothing cream", "Sun protection"]
  },
  {
    laserType: "Nd:YAG 1064nm",
    skinType: "Type V",
    indication: "Hair Removal",
    fluence: "25-35",
    spotSize: "12-15",
    pulseDuration: "30-50",
    cooling: "Cryogen 50/30",
    passes: "1",
    sessions: "6-10 sessions, 4-6 weeks apart",
    contraindications: ["Active infections", "History of keloids"],
    preCare: ["Shave area 24h prior", "Test spot highly recommended"],
    postCare: ["Apply soothing cream", "Sun protection", "Avoid scratching"]
  },
  {
    laserType: "Nd:YAG 1064nm",
    skinType: "Type VI",
    indication: "Hair Removal",
    fluence: "20-30",
    spotSize: "10-12",
    pulseDuration: "50-100",
    cooling: "Cryogen 50/30",
    passes: "1",
    sessions: "8-12 sessions, 4-6 weeks apart",
    contraindications: ["Active infections", "History of keloids"],
    preCare: ["Shave area 24h prior", "Test spot mandatory"],
    postCare: ["Apply topical steroid immediately to prevent PIH", "Strict sun protection"]
  },

  // CO2 Fractional - Acne Scars / Rejuvenation
  {
    laserType: "CO2 Fractional",
    skinType: "Type I",
    indication: "Acne Scars / Rejuvenation",
    fluence: "15-20 (mJ)",
    spotSize: "Scanner",
    pulseDuration: "CW/Pulsed",
    cooling: "Air Chiller",
    passes: "1-2",
    sessions: "3-5 sessions, 4-8 weeks apart",
    contraindications: ["Active acne", "Isotretinoin use within 6 months", "Active HSV infection"],
    preCare: ["Antiviral prophylaxis (Valacyclovir) 1 day before", "Avoid sun for 4 weeks", "Stop retinoids 1 week prior"],
    postCare: ["Apply thick layer of Vaseline/Aquaphor for 3-5 days", "Vinegar soaks 3x daily", "Strict sun avoidance"]
  },
  {
    laserType: "CO2 Fractional",
    skinType: "Type II",
    indication: "Acne Scars / Rejuvenation",
    fluence: "15-20 (mJ)",
    spotSize: "Scanner",
    pulseDuration: "CW/Pulsed",
    cooling: "Air Chiller",
    passes: "1-2",
    sessions: "3-5 sessions, 4-8 weeks apart",
    contraindications: ["Active acne", "Isotretinoin use within 6 months", "Active HSV infection"],
    preCare: ["Antiviral prophylaxis (Valacyclovir) 1 day before", "Avoid sun for 4 weeks", "Stop retinoids 1 week prior"],
    postCare: ["Apply Vaseline/Aquaphor for 3-5 days", "Vinegar soaks 3x daily", "Strict sun avoidance"]
  },
  {
    laserType: "CO2 Fractional",
    skinType: "Type III",
    indication: "Acne Scars / Rejuvenation",
    fluence: "10-15 (mJ)",
    spotSize: "Scanner",
    pulseDuration: "CW/Pulsed",
    cooling: "Air Chiller",
    passes: "1-2",
    sessions: "3-5 sessions, 4-8 weeks apart",
    contraindications: ["Active acne", "Isotretinoin use within 6 months", "Tendency for PIH"],
    preCare: ["Prescribe Tyrosinase inhibitor (Hydroquinone) 2 weeks prior", "Antiviral prophylaxis", "Strict sun avoidance"],
    postCare: ["Apply Vaseline/Aquaphor", "Topical steroid for 2 days to reduce inflammation", "Strict sun avoidance"]
  },
  {
    laserType: "CO2 Fractional",
    skinType: "Type IV",
    indication: "Acne Scars / Rejuvenation",
    fluence: "8-12 (mJ) - Low Density",
    spotSize: "Scanner",
    pulseDuration: "CW/Pulsed",
    cooling: "Air Chiller",
    passes: "1",
    sessions: "4-6 sessions, 6-8 weeks apart",
    contraindications: ["Active acne", "Keloid tendency", "Recent sun exposure"],
    preCare: ["Mandatory Hydroquinone 4% for 4 weeks prior", "Antiviral prophylaxis", "Test spot recommended"],
    postCare: ["Apply Vaseline/Aquaphor", "Topical steroid for 3 days", "Resume Hydroquinone after peeling stops"]
  },

  // Diode 810nm - Hair Removal
  {
    laserType: "Diode 810nm",
    skinType: "Type I",
    indication: "Hair Removal",
    fluence: "30-40",
    spotSize: "9x9",
    pulseDuration: "10-30",
    cooling: "Contact Cooling",
    passes: "Multi-pass",
    sessions: "6-8 sessions, 4-6 weeks apart",
    contraindications: ["Recent sun exposure", "Photosensitizing drugs"],
    preCare: ["Shave area 24h prior"],
    postCare: ["Soothing cream", "Sun protection"]
  },
  {
    laserType: "Diode 810nm",
    skinType: "Type III",
    indication: "Hair Removal",
    fluence: "20-30",
    spotSize: "9x9",
    pulseDuration: "30-50",
    cooling: "Contact Cooling",
    passes: "Multi-pass",
    sessions: "6-8 sessions, 4-6 weeks apart",
    contraindications: ["Recent sun exposure", "Photosensitizing drugs"],
    preCare: ["Shave area 24h prior"],
    postCare: ["Soothing cream", "Sun protection"]
  },
  {
    laserType: "Diode 810nm",
    skinType: "Type V",
    indication: "Hair Removal",
    fluence: "10-20",
    spotSize: "9x9",
    pulseDuration: "100-400",
    cooling: "Contact Cooling",
    passes: "Multi-pass",
    sessions: "8-10 sessions, 4-6 weeks apart",
    contraindications: ["Recent sun exposure", "Photosensitizing drugs"],
    preCare: ["Shave area 24h prior"],
    postCare: ["Soothing cream", "Sun protection"]
  },

  // IPL (Intense Pulsed Light) - Photorejuvenation
  {
    laserType: "IPL (Intense Pulsed Light)",
    skinType: "Type I",
    indication: "Photorejuvenation",
    fluence: "16-20",
    spotSize: "Filter dependent",
    pulseDuration: "2.5-5.0",
    cooling: "Gel / Contact",
    passes: "1-2",
    sessions: "3-5 sessions, 3-4 weeks apart",
    contraindications: ["Melasma", "Recent sun exposure"],
    preCare: ["Avoid sun strictly"],
    postCare: ["Strict sun protection", "Avoid heat"]
  },
  {
    laserType: "IPL (Intense Pulsed Light)",
    skinType: "Type III",
    indication: "Photorejuvenation",
    fluence: "12-16",
    spotSize: "Filter dependent",
    pulseDuration: "3.0-6.0",
    cooling: "Gel / Contact",
    passes: "1",
    sessions: "3-5 sessions, 3-4 weeks apart",
    contraindications: ["Melasma", "Recent sun exposure"],
    preCare: ["Avoid sun strictly"],
    postCare: ["Strict sun protection", "Avoid heat"]
  }
];

export function getGuideline(laserType: string, skinType: string): LaserGuideline | null {
  // Extract base type like "Type I" from "Type I (Light, Pale White)"
  const cleanSkinType = skinType.split(" ")[0] + " " + skinType.split(" ")[1];
  
  let match = laserGuidelines.find(g => g.laserType === laserType && g.skinType === cleanSkinType);
  
  // If no exact match, fallback to closest skin type for that laser
  if (!match) {
    const laserMatches = laserGuidelines.filter(g => g.laserType === laserType);
    if (laserMatches.length > 0) {
      match = laserMatches[laserMatches.length - 1]; 
    }
  }
  return match || null;
}
